import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NationalHolidayDetailService } from '../services/national-holiday-detail.service';

@Injectable()
export class NationalHolidayDetailResolver implements Resolve<any> {
  constructor(private readonly router: Router, private readonly natHolidayService: NationalHolidayDetailService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    const nationalHolidaySlug = route.params.nationalHolidaySlug;
    return this.natHolidayService.getNationalHolidayDetail$(nationalHolidaySlug).pipe(
      catchError((err: HttpErrorResponse) => {
        this.router.navigate(['/', '404']);
        return throwError(err);
      })
    );
  }
}
